export default __webpack_public_path__ + "static/media/Ellipse 117.859b5a17.svg";